'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisableCover = undefined;

var _DisableCover = require('./disable-cover/DisableCover');

var _DisableCover2 = _interopRequireDefault(_DisableCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DisableCover = _DisableCover2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/utils/index.js
// module id = 236
// module chunks = 4